import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  headerContainer: {
    '& .MuiToolbar-root': {
      maxWidth: '1440px',
      backgroundColor: Theme.palette.primary.main,
      justifyContent: 'space-between',
      paddingLeft: 40,
      paddingRight: 40,
      [Theme.breakpoints.down('sm')]: {
        paddingLeft: 16,
        paddingRight: 16,
      },
      [Theme.breakpoints.up('lg')]: {
        paddingLeft: 24,
        paddingRight: 24,
      },
      '& .headerTypography': {
        fontFamily: Theme.typography.base.semiBold,
        fontSize: Theme.typography.size[1],
      },
    },
    '&.cel': {
      backgroundColor: Theme.palette.primary.main,
    },
    '&.stretch': {
      '& .MuiToolbar-root': {
        maxWidth: 1080,
        [Theme.breakpoints.up('sm')]: {
          paddingLeft: 30,
          paddingRight: 30,
        },
        [Theme.breakpoints.up('md')]: {
          paddingLeft: 40,
          paddingRight: 40,
        },
        [Theme.breakpoints.up('xl')]: {
          padding: 0,
        },
      },
    },
  },
  navContainer: {
    width: '100%',
    maxWidth: 1440,
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0 auto',
    paddingRight: 34,
    '& a': {
      padding: 0,
    },
    [Theme.breakpoints.down('lg')]: {
      paddingRight: 0,
    },
  },
  footerToRight: {
    [Theme.breakpoints.up('lg')]: { marginLeft: '33% ' },
    [Theme.breakpoints.up('xl')]: {
      marginLeft: 'calc(((100% - 1440px)/ 2) + 360px)',
      maxWidth: '1080px',
      padding: '24px',
      boxSizing: 'border-box',
    },
  },
  logo: {
    fill: Theme.palette.white,
    height: '24px',
    width: '24px',
  },
  signOut: {
    display: 'flex',
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],

    '& a': {
      margin: 0,
      color: Theme.palette.white,
      fontFamily: 'inherit',
      fontSize: Theme.typography.size[2],

      '&:hover': {
        textDecoration: 'none',
      },
    },

    '& button': {
      padding: 0,
      color: Theme.palette.white,
      fontFamily: 'inherit',
      minWidth: 'auto',
      textTransform: 'capitalize',
      fontSize: Theme.typography.size[2],
    },

    '& .blankSpaceSpan': {
      padding: '0 8px',
    },

    '& .greetingHeader': {
      textTransform: 'capitalize',
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[1],
      [Theme.breakpoints.up('md')]: {
        fontSize: Theme.typography.size[2],
      },
    },

    '& .exit-icon': {
      [Theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    '& .exit-label': {
      [Theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  stretch: {
    '&> div': {
      maxWidth: 1080,
      [Theme.breakpoints.up('md')]: {
        paddingLeft: 50,
        paddingRight: 50,
      },
      [Theme.breakpoints.up('xl')]: {
        padding: 0,
      },
    },
  },
}));

export default useStyles;
